var _path, _g, _path2, _path3, _g2, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificateIssued(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 74,
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1545_2093)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1545_2093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0001H56.9999V55H20V18.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1545_2093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7227 51.2104V54.2773H47.1682V44.8416L46.0937 46.5132L41.6449 49.6871L42.6856 44.3222L47.1682 37.3492V18.7228H20.7227V44.851",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3626 32.0942L46.0939 46.5127L42.6855 44.3218L51.9542 29.9032L55.3626 32.0942Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6849 44.3214L41.6445 49.6865L46.0933 46.5123L42.6849 44.3214Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1545_2093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 37,
    height: 37
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0001H56.9999V55H20V18.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1545_2093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9542 31.1726L55.3615 32.0947L51.9531 29.9037L52.5458 28.9817C53.1509 28.0405 54.4043 27.768 55.3455 28.373C56.2867 28.978 56.5593 30.2314 55.9542 31.1726Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5586 49.6875C33.325 48.3095 34.3959 47.0872 35.7113 46.2101C36.2254 45.8673 37.0599 45.384 37.6602 45.7963C38.0412 46.0579 38.2134 46.5161 38.2616 46.9594C38.3557 47.8232 38.3906 48.4749 38.2741 49.6875C38.697 48.8035 39.5982 47.8719 40.5965 47.6853C41.0959 47.592 41.5835 47.804 41.6869 48.34C41.7511 48.6728 41.6473 49.6875 41.6473 49.6875",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5666 31.2432H25.5254V22.1148H33.5666V31.2432Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6953 23.5518H42.9978",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6953 26.7275H42.9978",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6953 29.9043H42.9978",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9981 38.1992H25.6621V34.6433H42.9981V38.1992Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.918 41.7617H35.8858",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.918 44.791H30.6112",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2619 25.9804C31.2619 26.9281 30.4936 27.6963 29.5459 27.6963C28.5983 27.6963 27.8301 26.9281 27.8301 25.9804C27.8301 25.0328 28.5983 24.2645 29.5459 24.2645C30.4936 24.2645 31.2619 25.0328 31.2619 25.9804Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.546 27.6963C29.546 27.6963 25.5254 27.5476 25.5254 31.2432H33.5666C33.5666 27.5518 29.546 27.6963 29.546 27.6963Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.9823 49.993C61.9967 66.7402 43.3889 76.1218 27.2521 73.5912C24.6262 73.1794 17.4277 71.9528 11.0542 66.1657C-1.21503 55.0251 -3.83905 32.9654 6.05826 17.4193C13.2618 6.1045 26.1745 -0.309274 38.4443 0.0114828C41.0871 0.0806602 51.2159 0.506533 60.1174 7.97986C61.4248 9.07751 64.3086 11.686 66.9074 15.8239C73.01 25.5409 73.535 39.0786 68.9823 49.993Z",
    fill: "#0095DF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1545_2093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(20 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIssued);
export default __webpack_public_path__ + "static/media/certificate_issued.d3b591833762b79e095fc60af1b45f33.svg";
export { ForwardRef as ReactComponent };